import { BloodGroupEnum } from "./blood-group-enum";

export class DonorsDto {
    donorsId?: number;
    donorName: string;
    phoneNo: string;
    country: string;
    state: string;
    district: string;
    constituency: string;
    bloodGroup: string;
    createdAt : Date;
    
    constructor(donorsId:number,donorName:string,phoneNo: string,country: string,state: string,district: string,constituency: string,bloodGroup: string,createdAt : Date,){
        this.donorsId = donorsId;
        this.donorName = donorName;
        this.phoneNo = phoneNo;
        this.country = country;
        this.state = state;
        this.district = district;
        this.constituency = constituency;
        this.bloodGroup = bloodGroup;
        this.createdAt = createdAt;
        
    }
}

// export const DonorDtoDefault : DonorsDto = {
//     donorsId: 0,
//     donorName: "",
//     phoneNo:"",
//     aadhaarNo:"",
//     bloodGroup:BloodGroupEnum.BPositive,
//     address:"",
//     city:"",
//     pinCode:"",
//     state:"",
//     country:"",
//     status:true,
//     isActive:true,
//     createdAt: Date
// };

